import axios from 'axios';
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from '../consts';
//import { AuthState } from '../slices/authSlice';

export const getStrainData = createAsyncThunk(
  'data/strain',
  async (shipId: number, { getState, rejectWithValue }) => {
    try {
      const { user } = <any> getState();
      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      // Add shipId as query parameter if provided
      const url = shipId 
        ? `${API_BASE_URL}/v1/data/strain?shipId=${shipId}`
        : `${API_BASE_URL}/v1/data/strain`;

      const { data } = await axios.get(url, config);
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getAverageStrain = createAsyncThunk(
  'data/strain/averageStrain',
  async ({startDate, endDate} : {startDate: string, endDate: string}, { getState, rejectWithValue }) => {
    try {
      const { user } = <any> getState();
      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };
      const { data } = await axios.get(API_BASE_URL + 
        `/v1/data/strain/averageStrain?startDate=${startDate}&endDate=${endDate}`, config);
      return data;
    } catch (error: any) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);